import { FC, ReactNode } from 'react'
import { pagePanel } from '../layout/page-styles'
import { cn } from '../../lib/utils'

type ButtonBigProps = {
  title: string
  value: string | number
  subValue?: string
  icon?: ReactNode
  color?: string
}

export const ButtonBig: FC<ButtonBigProps> = ({ title, value, subValue, icon }) => {
  return (
    <div className={cn(pagePanel, 'p-5 flex items-center gap-4')}>
      {icon ? (
        <div className="w-11 h-11 rounded-xl bg-primary-50 flex items-center justify-center text-primary-600 flex-shrink-0 ring-1 ring-primary-100">
          {icon}
        </div>
      ) : null}
      <div className="min-w-0">
        <p className="text-xs font-medium text-neutral-500 uppercase tracking-wide">{title}</p>
        <p className="text-2xl font-semibold text-neutral-900 mt-0.5">{value}</p>
        {subValue ? <p className="text-xs text-neutral-500 mt-0.5">{subValue}</p> : null}
      </div>
    </div>
  )
}
